import { useCore } from '@/composables/core'
import { EVENTS, WEBVIEW_TYPES } from '@/lib/consts.ts'
import { useEmitter } from '@/composables/emitter'
import { sanitizeUrl } from '@/lib/sanitize-url'

import {
  useVersionCheck,
  useLogger,
} from '@booksy-com/vue-tools'

const logger = useLogger('router.guard.reload-page')

export default function (to, from, next) {
  const emitter = useEmitter()
  const { store, router } = useCore()
  const { refreshRequired, resetRefreshRequired } = useVersionCheck()

  logger.debug(to.path)

  const isWebView = [WEBVIEW_TYPES.IOS, WEBVIEW_TYPES.ANDROID].includes(
    (store.state as { app: { webView: string } }).app.webView
  )

  if (!refreshRequired.value) {
    return next()
  }

  resetRefreshRequired() // Avoids infinite loops

  if (isWebView) {
    emitter.emit(EVENTS.WEB_VIEW_CLEAR_CACHE)
  } else {
    const resolvedRoute = router.resolve(to)
    const sanitizedRoute = sanitizeUrl(resolvedRoute.href)

    const isRootRelative = sanitizedRoute.startsWith('/') && !sanitizedRoute.startsWith('//')

    if (!isRootRelative) {
      window.location.reload()

      return
    }

    // nosemgrep: js-open-redirect-from-function
    window.location.assign(sanitizedRoute)
  }
}
